import React from 'react';
import '../footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <nav>
        <ul className="footer__links">
          <li><a href="/">Home</a></li>
          <li><a href="/docs">Docs</a></li>
          <li><a href="https://rapidapi.com/christopherkormpos/api/ieee-spectrum-api" target="_blank" rel="noreferrer">RapidAPI page</a></li>
          <li><a href="https://spectrum.ieee.org/type/news/" target="_blank" rel="noreferrer">IEEE Spectrum News</a></li>
        </ul>
      </nav>
      <div className="footer__icons">
        <a href="https://www.linkedin.com/in/christopher-kormpos-27808b194/" target="_blank" rel="noreferrer">
          <img className="footer__icon" src="./images/linkedin.png" alt="LinkedIn" />
        </a>
        <a href="https://github.com/christopherkormpos" target="_blank" rel="noreferrer">
          <img className="footer__icon" src="./images/github.jpg" alt="Github" />
        </a>
      </div>
      <p className="footer__copy">&copy; PhantomBit 2023</p>
    </footer>
  );
}

